import { token } from '@atlaskit/tokens';

import { type GroupBase, type StylesConfig } from './Select.tsx';

export const getBaseSelectMenuStyles = <
  Option extends object,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>
>(): StylesConfig<Option, IsMulti, Group> => ({
  menu: (base) => ({
    ...base,
    width: 'max-content',
    minWidth: '100%'
  })
});

export const getCompactSelectStyles = <
  Option extends object,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>
>(): StylesConfig<Option, IsMulti, Group> => ({
  menu: (base) => ({
    ...base,
    width: '100%',
    minWidth: '100%'
  }),
  control: (base, state) => ({
    ...base,
    alignItems: 'center',
    backgroundColor: token('color.background.input'),
    borderColor: state.isFocused ? token('color.border.focused') : token('color.border'),
    borderRadius: token('radius.medium'),
    borderStyle: 'solid',
    borderWidth: token('border.width'),
    boxSizing: 'border-box',
    boxShadow: 'none',
    display: 'flex',
    flexWrap: 'nowrap',
    font: token('font.body', '14px'),
    height: '34px',
    minHeight: '34px',
    paddingBlock: token('space.050', '4px'),
    paddingInlineStart: token('space.100', '8px'),
    '&:hover': {
      borderColor: state.isFocused ? token('color.border.focused') : token('color.border')
    }
  }),
  valueContainer: (base) => ({
    ...base,
    alignContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flex: '1 1 0',
    flexWrap: 'nowrap',
    height: '24px',
    minHeight: '24px',
    minWidth: '0',
    overflow: 'hidden',
    paddingBlock: '0',
    paddingInline: '0',
    width: '0'
  }),
  singleValue: (base) => ({
    ...base,
    alignItems: 'center',
    display: 'inline-flex',
    flex: '0 1 auto',
    margin: '0',
    maxWidth: '100%',
    minWidth: '0',
    overflow: 'hidden',
    position: 'relative',
    textOverflow: 'ellipsis',
    top: 'auto',
    transform: 'none',
    whiteSpace: 'nowrap'
  }),
  input: (base, state) => {
    const hasInputValue = Boolean(state.selectProps.inputValue);

    return {
      ...base,
      flex: hasInputValue ? '1 1 auto' : '0 0 1px',
      minWidth: hasInputValue ? '24px' : '1px'
    };
  },
  indicatorsContainer: (base) => ({
    ...base,
    alignItems: 'center',
    bottom: 'auto',
    display: 'flex',
    flex: '0 0 auto',
    position: 'static',
    right: 'auto',
    top: 'auto'
  }),
  placeholder: (base) => ({
    ...base,
    alignItems: 'center',
    display: 'inline-flex',
    margin: '0',
    position: 'relative',
    top: 'auto',
    transform: 'none'
  })
});
